import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { AscentLoginPageCopy } from '../ascent-login.config';
import { OAuthProvider } from '../../../login/services/oauth.service';

/**
 * In-page scaled render of the Mist login shell for Master Admin editing.
 * Does not boot Auth/Login services or a second SPA (no iframe).
 */
@Component({
  selector: 'app-login-page-preview',
  templateUrl: './login-page-preview.component.html',
  styleUrls: ['./login-page-preview.component.scss', '../ascent-login.theme.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginPagePreviewComponent implements AfterViewInit, OnChanges {
  @Input() copy: AscentLoginPageCopy;
  @ViewChild('stage', { static: false }) stage: ElementRef<HTMLElement>;
  @ViewChild('shell', { static: false }) shell: ElementRef<HTMLElement>;

  readonly productLogoUrl = '/images/ascent/auth/ascent_product_logo.svg';
  readonly footerLogoUrl = '/images/ascent/auth/company_logo.svg';
  readonly companySiteUrl = 'https://aerostudies.com/';
  /** Demo providers so the SSO block appears when showSso is on. */
  readonly previewProviders: OAuthProvider[] = [
    {
      name: 'microsoft',
      displayName: 'Microsoft',
      clientId: '',
      redirectUri: '',
      scope: '',
      authUrl: '',
      icon: ''
    },
    {
      name: 'google',
      displayName: 'Google',
      clientId: '',
      redirectUri: '',
      scope: '',
      authUrl: '',
      icon: ''
    }
  ];

  private readonly designWidth = 1440;

  ngAfterViewInit(): void {
    setTimeout(() => this.fit());
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.copy) {
      setTimeout(() => this.fit());
    }
  }

  @HostListener('window:resize')
  onResize(): void {
    this.fit();
  }

  private fit(): void {
    const stage = this.stage && this.stage.nativeElement;
    const shell = this.shell && this.shell.nativeElement;
    if (!stage || !shell) {
      return;
    }
    const scale = Math.min(1, stage.clientWidth / this.designWidth);
    shell.style.transform = 'scale(' + scale + ')';
    stage.style.height = Math.round(shell.scrollHeight * scale) + 'px';
  }
}
